import { EChartsCoreOption } from 'echarts';
import {
  ChartDataResponseResult,
  ChartProps,
  DataRecordValue,
  QueryFormColumn,
  QueryFormData,
  SetDataMaskHook,
} from '@superset-ui/core';
import {
  DEFAULT_LEGEND_FORM_DATA,
  EchartsLegendFormData,
} from '../../../types';
import { defaultLabelStyle } from './constants';
import { RGBAColor } from '../../types';

export type EchartsNestedPieFormData = QueryFormData &
  EchartsLegendFormData & {
    groupby: QueryFormData[];
    groupbyInner: QueryFormColumn;
    metric?: string;
    showLabels: boolean;
    tooltipFormat: string;
    labelFormat: string;
    labelBackgroundColor: RGBAColor;
    labelBorderColor: RGBAColor;
    labelRichStyle: string;
};

export interface EchartsNestedPieChartProps
  extends ChartProps<EchartsNestedPieFormData> {
  formData: EchartsNestedPieFormData;
  queriesData: ChartDataResponseResult[];
}

// @ts-ignore
export const DEFAULT_FORM_DATA: EchartsNestedPieFormData = {
  ...DEFAULT_LEGEND_FORM_DATA,
  showLabels: true,
  tooltipFormat: '{a} <br/>{b}: {c} ({d}%)',
  labelFormat: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
  labelBackgroundColor: { r: 250, g: 250, b: 250, a: 1 },
  labelBorderColor: { r: 0, g: 0, b: 0, a: 1 },
  labelRichStyle: defaultLabelStyle,
};

export interface NestedPieChartTransformedProps {
  formData: EchartsNestedPieFormData;
  height: number;
  width: number;
  echartOptions: EChartsCoreOption;
  setDataMask: SetDataMaskHook;
  labelMap: Record<string, DataRecordValue[]>;
  seriesA: QueryFormColumn;
  seriesB: QueryFormColumn;
}